import { html, type Html, Page } from 'rune-ts';
import klass from './CreatorViewList.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { footer_links } from '../../components/cells/Footer/constant';
import { Pagination, PaginationChangeEvent } from '../../components/cells/Pagination/Pagination';
import { updateUrlParams } from '../../../../../modules/Util/S/Function/util';
import { CreatorViewListItemData } from '../../../features/CreatorView/type';
import { BaseLayoutOptions } from '../../../features/Core/service';
import { type ProductCardViewData } from '../../../features/ProductList/type';
import { FloatingButton_recent_product } from '../../components/cells/FloatingBox/FloatingButtons/FloatingButton_recent_product';
import { FloatingBox } from '../../components/cells/FloatingBox/FloatingBox';
import { CoreUiS } from '../../../features/Core/outbound/share';
import { TabListView } from '@services/MarppleShop/shared/components/cells/TabList/TabListView.ts';
import { CardCreatorViewView } from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/CardCreatorview/CardCreatorViewView.ts';
import { pipe } from '@fxts/core';
import { makeEmptyScreenNavigate } from '@services/MarppleShop/shared/app/navigate.ts';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr.ts';

export type CreatorViewListPageData = {
  creator_views: CreatorViewListItemData[];
  counts: number;
  current_page: number;
  total_page: number;
  recent_product?: ProductCardViewData;
  layout_options: BaseLayoutOptions;
};

export class CreatorViewListPage extends Page<CreatorViewListPageData> {
  override onMount() {
    super.onMount();

    this.delegate(PaginationChangeEvent, Pagination, function handleChangePage(e) {
      location.href = updateUrlParams(location.href, { page: e.detail.page });
    });
  }

  protected override template(): Html {
    const { creator_views, current_page, total_page, layout_options } = this.data;

    const { is_mobile } = layout_options;

    const body = html`
      <div class="${klass.body_container}">
        <!--    타이틀    -->
        ${is_mobile
          ? html`<div class="${klass.tab_list_wrapper}">
              ${new TabListView({
                tabs: [
                  {
                    tab_title: ET('mps2::section_title::section_tabs::popup_store'),
                    href: `/${ET.lang}/@/popup-store`,
                    selected: false,
                  },
                  {
                    tab_title: ET('mps2::section_title::section_tabs::creator_view'),
                    href: `/${ET.lang}/@/creator_views`,
                    selected: true,
                  },
                ],
              })}
            </div>`
          : html`<div class="${klass.page_title}">
              ${CoreUiS.makePopupStoreTitle(is_mobile, 'creator_view')}
            </div>`}

        <ul class="${klass.creator_view_container}">
          ${creator_views.map(
            (creatorView) =>
              html`<li>
                <article>
                  <a
                    href="${`/${ET.lang}/@/creator_views/${creatorView.id}`}"
                    data-post-message="${pipe(
                      `/${ET.lang}/@/creator_views/${creatorView.id}`,
                      makeEmptyScreenNavigate,
                      dataStr,
                    )}"
                  >
                    ${new CardCreatorViewView({
                      device: is_mobile ? 'Mobile' : 'PC',
                      layout: 'List',
                      ...creatorView,
                    })}
                  </a>
                </article>
              </li>`,
          )}
        </ul>

        <div class="${klass.pagination_container}">
          ${total_page > 1
            ? new Pagination({
                page: current_page,
                size: is_mobile ? 5 : 10,
                total: total_page,
              })
            : ''}
        </div>
      </div>
    `;

    return html`
      <div class="${klass.page}">
        ${new LayoutView(
          {
            body,
            footer_data: { ...footer_links, is_mobile: layout_options.is_mobile, lang: ET.lang },
          },
          {
            ...layout_options,
            floating_box: {
              recent_product: FloatingButton_recent_product.makeProps(this.data.recent_product),
              async renderHook(view: FloatingBox) {
                await FloatingBox.refreshRecentProductFloatingButton(view);
              },
            },
            has_bottom_tab_bar: true,
            selected_bottom_tab_idx: 2,
          },
        )}
      </div>
    `;
  }
}
